<template>
  <v-layout :title="$t('shopping_cart_review.order_review')">
    <vue-element-loading
      :active="mainpatient == undefined"
      :is-full-screen="true"
    />
    <VDrugsSummary
      v-if="cartData.item_list"
      :items="cartData.item_list.drugs"
      :raw_amount="cartData.amount"
      actionscolumn
      picturecolumn
      statecolumn
      taxcolumn
      quantityinput
      offercodeinput
      priceswarning
      :isBusy="busy"
      :busyItemUuid="busyItemUuid"
      @modifyQuantity="setItemQuantity"
      @deleteButtonClick="deleteItem"
    />

    <VButtonGroup
      :primary_to="{
        name: 'cart_confirm',
        params: { checkout_uuid: cartData.checkout },
      }"
      :primary_text="$t('shopping_cart_review.continue')"
      :secondary_text="$t('shopping_cart_review.keep_buying')"
      between
    />
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import VLayout from "@/layouts/Default";
import VDrugsSummary from "@/components/VDrugsSummary";
import { Amount } from "@/lib/amount.js";
import VButtonGroup from "@/components/VButtonGroup";

export default {
  name: "shopping-cart-review",
  components: {
    VLayout,
    VDrugsSummary,
    VButtonGroup,
  },
  data() {
    return {
      selectedAddressUuid: "",
      amount_object: Amount,
      busy: false,
      busyItemUuid: undefined,
      loading: undefined,
    };
  },
  computed: {
    ...mapGetters("shoppingcart", ["cartData"]),
    ...mapState({
      mainpatient: (state) => state.naturalperson.mainpatient,
    }),
  },
  created() {
    if (!this.mainpatient) {
      this.$router.push({
        name: "patientdata",
      });
    } else {
      this.loadShoppingCart();
    }
  },
  methods: {
    loadShoppingCart() {
      this.busy = true;
      this.$store.dispatch("shoppingcart/REQUEST_ACTIVE_CART").then(
        () => {
          // Redireccionamos a la home si el total es 0
          if (this.$route.params.subaction == "confirm") {
            this.$router.push({
              name: "cart_confirm",
              params: { checkout_uuid: this.cartData.checkout },
            });
          } else if (this.cartData.amount.total == 0) {
            this.$router.push({ name: "home" });
          }
          this.busy = false;
        },
        (err) => {
          this.busy = false;
          this.$sentry({ capture: err });
          this.mnotify_error({
            text: this.$t("shopping_cart_review.error.load_cart"),
          });
        }
      );
    },
    setItemQuantity(item, new_value) {
      if (this.busy) {
        return;
      }
      const previous_quantity = item.quantity;
      this.busy = true;
      this.busyItemUuid = item.uuid;

      this.$store
        .dispatch("shoppingcart/SET_QUANTITY", {
          price_uuid: item.price.price_uuid,
          previous_quantity: previous_quantity,
          item_uuid: item.uuid,
          quantity: new_value,
        })
        .then(
          () => {
            this.busy = false;
            this.busyItemUuid = undefined;
          },
          (err) => {
            this.busy = false;
            this.busyItemUuid = undefined;
            if ((err.response || {}).status == 404) {
              this.mnotify_error({
                text: this.$t("shopping_cart_review.error.no_longer_exists"),
              });
              this.loadShoppingCart();
            } else {
              this.$sentry({ capture: err });
              this.mnotify_error({
                text: this.$t("shopping_cart_review.error.set_quantity"),
              });
            }
          }
        );
    },
    deleteItem(item) {
      if (this.busy) {
        return;
      }
      this.busy = true;
      this.busyItemUuid = item.uuid;

      this.$store
        .dispatch("shoppingcart/REMOVE_PRODUCT", {
          price_uuid: item.price.price_uuid,
          item_uuid: item.uuid,
        })
        .then(
          () => {
            this.busy = false;
            this.busyItemUuid = undefined;
          },
          (err) => {
            this.busy = false;
            this.busyItemUuid = undefined;
            if ((err.response || {}).status == 404) {
              this.mnotify_error({
                text: this.$t("shopping_cart_review.error.no_longer_exists"),
              });
              this.loadShoppingCart();
            } else {
              this.$sentry({ capture: err });
              this.mnotify_error({
                text: this.$t("shopping_cart_review.error.delete"),
              });
            }
          }
        );
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        shopping_cart_review: {
          order_review: "Order review",
          continue: "Continue",
          keep_buying: "Keep buying",
          error: {
            load_cart: "Cannot load shopping cart",
            set_quantity: "Cannot modify quantity",
            delete: "Cannot remove product from cart",
            no_longer_exists: "This product is no longer in your cart",
          },
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
